import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '../Button';

import {
  SCard, SHeader, SErrorIcon, SContent, SFooter,
} from './styled';

const BoardLeave = ({ isLast, onCancel, onLeave }) => {
  const { t } = useTranslation('board');

  return (
    <SCard>
      <SHeader>
        <SErrorIcon />
        {t('leave.title')}
      </SHeader>
      <SContent>
        {t(`leave.message.${isLast ? 'lastUser' : 'notLastUser'}`)}
      </SContent>
      <SFooter>
        <Button variant="secondary" onClick={onCancel}>
          {t('leave.cancel')}
        </Button>
        <Button variant="primary" onClick={onLeave}>
          {t('leave.leave')}
        </Button>
      </SFooter>
    </SCard>
  );
};

BoardLeave.propTypes = {
  isLast   : PropTypes.bool.isRequired,
  onCancel : PropTypes.func.isRequired,
  onLeave  : PropTypes.func.isRequired,
};

export default BoardLeave;
